import React from "react";
import {CommandBar} from "@fluentui/react";

import styles from "./IsaacCommandBar.module.scss";
import type IsaacCommandBarProps from "./IsaacCommandBarProps";

const IsaacCommandBar: React.FunctionComponent<IsaacCommandBarProps> = ({
  items,
  farItems,
}) => {
  return (
    <CommandBar
      items={items}
      farItems={farItems}
      className={styles.commandBar}
    />
  );
};

export default IsaacCommandBar;
